module.exports = __webpack_public_path__ + "img/view-one-pane-active.880edd27.svg";